import { Modal } from "./base_modal";
import { renderIssueGroups } from "./utils";
import { COMMON_ERROR_KEYS } from "../datatable/free_phones/phone_statuses.config";

/** Модальное окно результатов проверки */
export class CheckResultModal extends Modal {
  constructor(data) {
    super({ className: "check-result-modal" });

    this.data = data;
  }

  /** Строит содержимое модального окна */
  buildContent() {
    const hasErrors = Boolean(Object.keys(this.data.errors || {}).length);
    const hasWarnings = Boolean(Object.keys(this.data.warnings || {}).length);
    const titleText = this.data.success ? "Проверка прошла успешно" : "Обнаружены проблемы";
    const contentClass = this.data.success ? "check-result-success" : "check-result-issues";
    const applyDisabled = hasErrors;

    const bodyHtml = this.data.success
      ? `
        <div class="check-success-msg">
          <p>Проверка успешно завершена. Замечаний не обнаружено.</p>
        </div>
      `
      : `
        ${hasErrors ? this.renderErrorsSection() : ""}
        ${hasWarnings ? this.renderWarningsSection() : ""}
      `;

    return `
      <div class="check-result-content ${contentClass}">
        <h3>${titleText}</h3>
        ${bodyHtml}
        <div class="modal-actions">
          <button class="btn-cancel">Отменить</button>
          ${!applyDisabled ? '<button class="btn-apply">Применить</button>' : ""}
        </div>
      </div>
    `;
  }

  /** Рендерит блок с ошибками */
  renderErrorsSection() {
    return `
      <div class="check-section check-section-errors">
        <div class="check-section-header">Ошибки</div>
        <div class="check-section-list">
          ${renderIssueGroups(this.data.errors)}
        </div>
      </div>
    `;
  }

  /** Рендерит блок с предупреждениями */
  renderWarningsSection() {
    return `
      <div class="check-section check-section-warnings">
        <div class="check-section-header">Предупреждения</div>
        <div class="check-section-list">
          ${renderIssueGroups(this.data.warnings)}
        </div>
      </div>
    `;
  }

  /** Настраивает обработчики */
  setupHandlers({ modal, close }) {
    modal.querySelector(".btn-cancel")?.addEventListener("click", () => close(false));
    modal.querySelector(".btn-apply")?.addEventListener("click", () => close(true));
  }

  /** Открывает модальное окно */
  async show() {
    return this.open({
      content: this.buildContent(),
      onInit: ({ modal, close }) => this.setupHandlers({ modal, close }),
    });
  }
}
